import React from "react";
import GridHeader from "./Grid/GridHeader";
import { Alert, Container } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../../components/Common/withRouter";
import { DF_OT0014Context } from "./context";

function DF_OT0014(props) {
  document.title = "Defender | Cancelar Agendamento";
  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);

  if (!parseParams.get("ID_Arquivo")) {
    return (
      <Alert color="danger">
        Não é possível acessar essa transação sem parametros
      </Alert>
    );
  }

  return (
    <>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <DF_OT0014Context.Provider
        value={{
          parseParams,
        }}
      >
        <div className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader />
            <GridBody />
          </Container>
        </div>
      </DF_OT0014Context.Provider>
    </>
  );
}

export default withRouter(DF_OT0014);
